// import { useLocation } from 'react-router-dom';
import { Container } from '@mui/material'; // import { Routes } from '@enums';

import { CopyComponent, PartnersComponent } from '@components/footer/components';
import { FooterContainer, StyledCopyContainer, StyledPartnersContainer } from './footer.styles';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var Footer = function Footer(_ref) {
  var isFooterVisible = _ref.isFooterVisible;
  // const { pathname } = useLocation();
  // const isSchemaPage = pathname.split('/').includes(Routes.Events.replace('/', '')) && pathname.split('/').length === 4;
  return isFooterVisible ? /*#__PURE__*/_jsxs(FooterContainer, {
    component: "footer",
    $hideOnMobile: false,
    children: [/*#__PURE__*/_jsx(StyledPartnersContainer, {
      children: /*#__PURE__*/_jsx(Container, {
        fixed: true,
        children: /*#__PURE__*/_jsx(PartnersComponent, {})
      })
    }), /*#__PURE__*/_jsx(StyledCopyContainer, {
      children: /*#__PURE__*/_jsx(Container, {
        fixed: true,
        children: /*#__PURE__*/_jsx(CopyComponent, {})
      })
    })]
  }) : null;
};

export { Footer };